import { Reducer } from 'redux';
import { CategoriesState, CategoriesTypes } from './types';

const INITIAL_STATE: CategoriesState = {
  categories: [],
  hasError: false,
  isLoading: false,
  total: 0,
};

const reducer: Reducer<CategoriesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CategoriesTypes.LOAD_REQUEST:
      return { ...state, isLoading: true };
    case CategoriesTypes.LOAD_FAILURE:
      return { ...state, isLoading: false, hasError: true };
    case CategoriesTypes.LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        categories: action.payload.data,
        total: action.payload.total,
      };
    default:
      return state;
  }
};

export default reducer;
